// extracted by mini-css-extract-plugin
export default {"search-container":"search_search-container__JvJzP","search-button":"search_search-button__iDJPn","expanded":"search_expanded__0jkRJ","search-input":"search_search-input__5E15C"};